import { makeModuleStateSelector } from "@client/content/selectors";
import { defaultState, previewState } from "./reducer";
import { type Unsubscribe } from "./types";

export const localStateSelector = makeModuleStateSelector<Unsubscribe.AppState>(defaultState, previewState);
